<template>
  <div class="talent_list">
    <div class="container">
      <el-card class="labelStyle" :body-style="{ padding: '12px 16px' }">
        <el-form label-width="100px">
          <el-form-item label="所在城市：">
            <CascaderArea
              :country="queryInfo.personCountry"
              :province="queryInfo.personProvince"
              :city="queryInfo.personCity"
              @searchArae="searchArae"
              class="CascaderArea"
            />
          </el-form-item>
          <el-form-item label="目前状态：">
            <radio-select
              :code.sync="queryInfo.state"
              type-code="010"
              query-name="state"
              name="目前状态"
              @onChange="onChange"
            />
          </el-form-item>
          <el-form-item label="工作经验：">
            <radio-select
              :code.sync="queryInfo.workingYears"
              type-code="003"
              query-name="workingYears"
              name="工作年限"
              @onChange="onChange"
            />
          </el-form-item>
          <el-form-item label="职位类型：">
            <multiSelect
              typeCode="008"
              @change="changePositionType"
              :code.sync="queryInfo.personType"
            />
          </el-form-item>
          <el-form-item label="年龄：">
            <AgeChioce
              :parentYear="queryInfo.beginAge"
              :parentMonth="queryInfo.finishAge"
              @dateChange="ageChange"
            />
          </el-form-item>
        </el-form>
      </el-card>
      <el-card style="margin-top: 12px" :body-style="{ padding: '12px 16px' }">
        <div class="enterporise_list_input_add">
          <div class="input_new">
            <el-input
              placeholder="请输入关键字"
              v-model="queryInfo.personSchedule"
              class="input-with-select"
              clearable
            >
              <el-button slot="append" icon="el-icon-search" @click="searchTalent"></el-button>
            </el-input>
          </div>
          <el-button
            type="primary"
            class="add_enterprise"
            v-has-permission="'/person/insertPerson'"
            @click="addClient()"
            icon="el-icon-plus"
            >新增人才</el-button
          >
          <!-- <el-button type="primary" class="add_enterprise">+上传简历</el-button> -->
          <up-load
            permission="/resume/ResumeParser"
            name="上传简历"
            icon="el-icon-plus"
            @fileClicks="fileClicks"
            class="uploadTalent"
          ></up-load>
        </div>
      </el-card>
      <el-card
        style="margin-top: 6px"
        v-for="(item, index) in clientTableData"
        :key="index"
        class="contentInfo"
      >
        <div>
          <div class="listStyle flexOne">
            <div class="flexAround">
              <div class="flexAround">
                <div>
                  <img
                    :src="item.headPortraits"
                    alt=""
                    v-if="item.headPortraits"
                    @click="viewItem(item)"
                  />
                  <img :src="pro" alt="" v-else @click="viewItem(item)" />
                </div>
                <div style="margin-left: 10px" class="cloumFlex">
                  <div class="jobTitle">
                    <div>{{ item.name }}</div>
                    <div class="operation1" v-if="item.state && item.state == '待就业'">
                      {{ item.state }}
                    </div>
                    <div class="operation2" v-if="item.state && item.state == '在职'">
                      {{ item.state }}
                    </div>
                    <div class="operation3" v-if="item.state && item.state == '已推荐'">
                      {{ item.state }}
                    </div>
                  </div>
                  <div class="positionType" style="margin: 6px 0">
                    <span>{{ item.currentIndustry }}</span>
                    <span style="margin: 0px 5px" v-if="item.currentIndustry">|</span>
                    <!-- <span v-if="item.personCountry" style="margin-right: 2px">{{
                  item.personCountry
                }}</span> -->
                    <span v-if="item.personProvince" style="margin-right: 2px">{{
                      item.personProvince
                    }}</span>
                    <span v-if="item.personCity">{{ item.personCity }}</span>
                    <span style="margin: 0px 5px" v-if="item.workingYears">|</span>
                    <span v-if="item.workingYears">{{ item.workingYears }}</span>
                  </div>
                  <div class="positionType" v-if="item.personType">
                    职位类型：<span>{{ item.personType }}</span>
                  </div>
                </div>
              </div>
              <div class="timeline" v-if="item.personExperience">
                <el-timeline :reverse="true">
                  <el-timeline-item
                    v-for="(items, index) in item.personExperience"
                    :key="index + 10"
                    v-show="index < 3"
                  >
                    <span style="color: #808080; margin-right: 5px" class="endTimeStyle"
                      >{{ items.inductionTime }}-
                      <span v-if="items.quitTime !== '1999'">{{ items.quitTime }}</span>
                      <span v-else style="color: #999999">至今</span></span
                    >
                    <span style="color: #1a1f33; margin-right: 5px" v-if="items.companyName">{{
                      items.companyName
                    }}</span>
                    <span style="color: #1a1f33; margin-right: 5px" v-if="items.position">{{
                      items.position
                    }}</span>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
            <div class="cloumFlexBetween">
              <div class="flexOne">
                <div class="flexNormal">
                  <div class="flexNormal uploadFile" style="margin-right: 10px">
                    <!-- <dic-button icon="icon-jr-icon-person" text="编辑" />
                  <span style="color: #4d70fa">上传简历</span> -->
                    <up-load
                      permission="/resume/ResumeParser"
                      name="上传简历"
                      icon="icon-jr-icon-person"
                      :personnelCode="item.personCode"
                      @fileClicks="fileClicks"
                      :personCode="item.personCode"
                    ></up-load>
                  </div>
                  <div v-if="addHasPermission" class="flexNormal" style="margin-right: 10px">
                    <dic-button icon="icon-jr-icon-people" text="添加到候选人" />
                    <span style="color: orange" @click="searchCandidate(item.personCode)"
                      >添加到候选人</span
                    >
                  </div>
                  <div
                    v-if="editHasPermission"
                    class="flexNormal"
                    style="margin-right: 10px"
                    @click="editItem(item)"
                  >
                    <dic-button icon="icon-jr-icon-modify" text="编辑" />
                    <span style="color: #17757a">编辑</span>
                  </div>
                  <div
                    v-if="deleteHasPermission"
                    class="flexNormal"
                    @click="deleteItem(item)"
                    style="margin-right: 10px"
                  >
                    <dic-button icon="icon-jr-icon-delete" text="删除" />
                    <span style="color: #ff6c66">删除</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottomFont">
            <p style="font-size: 13px">信息来源：{{ item.skills }}</p>
            <p style="font-size: 13px">最近更新时间：{{ item.updateTime }}</p>
          </div>
        </div>
      </el-card>
    </div>
    <div class="pagination">
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[30, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      class="candidateClass"
      :visible.sync="candidateVisible"
      width="40%"
      :before-close="handleCloseCandidate"
      center
    >
      <title-bar slot="title" title="添加到候选人" />
      <div class="search-input">
        <el-input placeholder="请输入关键词" v-model="enterprise" clearable>
          <el-button slot="append" icon="el-icon-search" @click="searchEnterprise" />
        </el-input>
      </div>
      <div style="border-bottom: 1px solid #333333; height: 15px; width: 100%"></div>
      <p>选择项目</p>
      <div class="hasAddEnterprise">
        <div
          v-for="(item, index) in targetEnterpriseList"
          :key="index"
          class="targetEnterprise enterpriseInfo"
        >
          <div class="targetEnterpriseContent">
            <div class="left">
              <el-image
                class="companyLogo"
                :src="item.companyLogoKey"
                style="width: 80px; height: 80px"
                fit="fit"
              />
              <div class="info">
                <div style="display: flex">
                  <div class="companyFullName">{{ item.corporateName }}</div>
                  <div class="post">
                    {{ item.post }}
                  </div>
                  <div class="itemNo">[{{ item.itemNo }}]</div>
                </div>
                <div
                  v-if="item.projectSchedule"
                  class="projectSchedule"
                  :class="{
                    earlier: item.projectSchedule === '前期筹备',
                    accomplish: item.projectSchedule === '已完成',
                    cancel: item.projectSchedule === '已取消'
                  }"
                >
                  <span></span>{{ item.projectSchedule }}
                </div>
              </div>
            </div>
            <div style="margin-right: 2%">
              <el-checkbox v-model="item.enterpriseTrue"></el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addCandidate">确 定</el-button>
        <el-button @click="candidateVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import CascaderArea from '@/components/CascaderArea.vue'
import AgeChioce from '@/components/AgeChioce.vue'
import radioSelect from '@/components/RadioSelect.vue'
import DicButton from '@/components/DicButton.vue'
import {
  deletePersonBypercode,
  getHomePage,
  listPerson,
  saveIntermediateList
} from '@/api/talent.js'
import multiSelect from '@/components/MultiSelect.vue'
import UpLoad from '@/components/UploadFileDIY.vue'
import { pagination } from '@/mixins/pagination'
// import DicButton from '@/components/DicButton.vue'
import pro from '../../../../static/images/pro.png'
const defaultQueryObj = Object.freeze({
  beginAge: 0, //开始年龄
  currentIndustry: '', //所在行业
  finishAge: 0, //结束年龄
  personCity: '', //客户所属城市
  personCountry: '', //客户所属省份
  personProvince: '', //客户所在地区
  personType: [], //职位类型
  state: '', //目前状态
  workingYears: '', //工作年限
  // order: '', //排序
  pageNum: 1, //页数
  pageSize: 30, //大小
  size: '', //所选条数
  personSchedule: ''
})
export default {
  mixins: [pagination],
  components: {
    UpLoad,
    multiSelect,
    CascaderArea,
    radioSelect,
    DicButton,
    AgeChioce,
    TitleBar
    // DicButton
  },
  created() {
    this.search()
  },
  computed: {
    addHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.flatMap((item) => item.children.map((i) => i.path))
        }
      )
      const hasPermission = userPermissions.includes('/projectCenter/listPerson')
      return hasPermission
    },
    editHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.flatMap((item) => item.children.map((i) => i.path))
        }
      )
      const hasPermission = userPermissions.includes('/person/getParticularsPersonByid')
      return hasPermission
    },
    deleteHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.flatMap((item) => item.children.map((i) => i.path))
        }
      )
      const hasPermission = userPermissions.includes('/person/deletePersonBypercode')
      return hasPermission
    }
  },
  data() {
    return {
      personCodeCandidate: '',
      candidateVisible: false,
      queryInfo: { ...defaultQueryObj },
      clientTableData: [],
      targetEnterpriseList: [],
      enterprise: '',
      pro,
      total: null,
      personCode: '',
      dynamicTags: [
        {
          name: '学历要求',
          tagName: 'educationalRequirements'
        },
        {
          name: '职位类型',
          tagName: 'positionType'
        }
      ]
    }
  },
  methods: {
    onChange(val, queryName, name) {
      if (!this.dynamicTags.some((item) => item.tagName === queryName)) {
        this.dynamicTags.push({
          name,
          tagName: queryName
        })
      }
      this.search()
    },
    // async getHomePage() {
    //   const res = await getHomePage(this.queryInfo)
    //   if (res.data.resultCode == 200) {
    //     this.clientTableData = res.data.data.list
    //     this.total = res.data.data.total
    //   }
    // },
    searchTalent() {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = 30
      this.search()
    },
    async search() {
      let queryInfoOnes = JSON.stringify(this.queryInfo)
      let queryInfoOne = JSON.parse(queryInfoOnes)
      if (queryInfoOne.beginAge) {
        queryInfoOne.beginAge = queryInfoOne.beginAge.toString()
      } else {
        queryInfoOne.beginAge = ''
      }
      console.log(queryInfoOne)
      console.log(this.queryInfo)
      if (queryInfoOne.finishAge) {
        queryInfoOne.finishAge = queryInfoOne.finishAge.toString()
      } else {
        queryInfoOne.finishAge = ''
      }
      // if (queryInfoOne.personType[0] == ['不限']) {
      //   queryInfoOne.personType = []
      // }
      const res = await getHomePage(queryInfoOne)
      if (res.data.code == 200) {
        this.clientTableData = res.data.data.content
        this.total = res.data.data.totalElements
        this.clientTableData.forEach((item) => {
          if (item.personExperience) {
            // this.clientTableData[index].personExperience =
            item.personExperience.reverse()
          }
        })
      }
    },
    closeTag(index, name) {
      this.dynamicTags.splice(index, 1)
      this.queryInfo[name] = ''
      this.search()
    },
    // 添加
    addClient() {
      console.log(this.queryInfo)
      this.$router.push({
        name: 'TalentMessage',
        query: {
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    viewItem(row) {
      if (this.editHasPermission) {
        this.$router.push({
          name: 'TalentMessageView',
          query: {
            id: row.personCode,
            clientType: 1,
            searchInfo: JSON.stringify(this.queryInfo)
          }
        })
      } else {
        this.$message.warning('暂无权限')
      }
    },
    // 修改
    editItem(row) {
      // console.log("编辑数据",row)
      this.$router.push({
        name: 'TalentMessage',
        query: {
          id: row.personCode,
          clientType: 1,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    // 删除
    deleteItem(row) {
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const data = row.personCode
          const { data: res } = await deletePersonBypercode({ preCode: data })
          if (res.resultCode == 200) {
            this.$message.success('删除成功')
            // this.$router.go(0)
            this.search()
          }
        })
        .catch(() => {})
    },
    searchArae(val) {
      this.queryInfo.personCountry = val.country

      this.queryInfo.personProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.personCity = val.city
      }

      this.search()
    },
    ageChange(year, month) {
      this.queryInfo.beginAge = year

      this.queryInfo.finishAge = month

      this.search()
    },
    changePositionType(data) {
      this.queryInfo.personType = data
      this.search()
    },
    fileClicks() {
      // this.search()
      this.$router.push({
        path: '/dataManagement/talentList'
      })
      this.search()
    },
    async searchCandidate(data) {
      this.searchEnterprise()
      this.personCodeCandidate = data
      this.candidateVisible = true
    },
    async searchEnterprise() {
      const res = await listPerson({ corporateName: this.enterprise })
      if (res.data.resultCode == 200) {
        this.targetEnterpriseList = res.data.data
        this.targetEnterpriseList.forEach((item) => {
          this.$set(item, 'enterpriseTrue', false)
        })
        console.log(this.targetEnterpriseList)
      }
    },
    handleCloseCandidate() {
      this.enterprise = ''
      this.candidateVisible = false
    },
    async addCandidate() {
      console.log(this.targetEnterpriseList)
      var addproject = {
        projectId: [],
        personCode: ''
      }
      addproject.personCode = this.personCodeCandidate
      this.targetEnterpriseList.forEach((item) => {
        if (item.enterpriseTrue) {
          addproject.projectId.push(item.id)
        }
      })
      console.log(addproject.projectId)
      if (addproject.projectId.length == 0) {
        return this.$message('请勾选数据')
      }
      const res = await saveIntermediateList(addproject)
      if (res.data.resultCode == 200) {
        this.$message.success('添加候选人成功')
        this.candidateVisible = false
      } else {
        this.$message.error('添加候选人失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 82vh;
  overflow: scroll;
}

.pagination {
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
}

.contentInfo {
  /deep/ .el-card__body {
    padding: 10px;
  }
}

.talent_list {
  .el-table {
    /deep/tbody tr:hover > td {
      // background-color: #90c0f1;
      background-color: rgba(23, 117, 122, 0.1);
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 5px;
  }

  .enterporise_list_input_add {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    // border-bottom: 1px solid #e5e5e5;
    // margin-bottom: 20px;
    /deep/ .input-with-select {
      width: 320px;
      margin-right: 50px;
    }

    .input_new {
      /deep/ .el-button {
        border-radius: 0 4px 4px 0;
        height: 40px;
      }

      /deep/ .el-button--default {
        background-color: #17757a;

        i {
          color: #fff;
        }
      }
    }

    .add_enterprise {
      background-color: #17757a;
      border-color: #17757a;
    }
  }

  .enterprise_table {
    margin-top: 20px;
    width: 100%;

    .el_image {
      width: 48px;
      height: 48px;
      border-radius: 4px;
    }
  }

  .operation_bottom {
    .operation_border {
      font-size: 18px;
      color: #e8e8e8;
    }
  }

  .CascaderArea {
    /deep/ .el-input__inner {
      border: 1px solid #17757a;
      color: #17757a;
      height: 34px;
      line-height: 34px;
    }
  }

  /deep/ .el-image__inner {
    border-radius: 5px;
  }
}

.listStyle {
  padding: 10px;
  border-bottom: 1px solid #e5e5e5;

  img {
    width: 90px;
    height: 90px;
    // padding: 5px;
    cursor: pointer;
    border-radius: 5px;
  }

  .timeline {
    // margin-left: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    /deep/ .el-timeline {
      display: flex;
      flex-direction: column;

      .el-timeline-item {
        padding: 20px 0 0 0;
      }
    }
  }
}

.flexOne {
  display: flex;
  justify-content: space-between;
}

.cloumFlex {
  width: 350px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.flexNormal {
  display: flex;
  align-items: center;
  cursor: pointer;

  /deep/ .el-button i {
    font-size: 19px !important;
  }

  /deep/ .icon-jr-icon-person {
    color: #4d70fa;
  }

  /deep/ .icon-jr-icon-people {
    color: orange;
  }
}

.flexAround {
  display: flex;
  align-items: center;

  .jobTitle {
    font-size: 20px;
    font-weight: 600;
    display: flex;
    justify-items: center;
  }

  .positionType {
    color: #333333;
  }

  span {
    display: inline-block;
  }
}

.bottomFont {
  padding-top: 10px;
  text-align: right;
  color: #999999;
}

/deep/ .el-timeline-item__node {
  border: 3px solid #17757a;
  box-sizing: border-box;
  background-color: #fff;
}

/deep/ .el-timeline-item__tail {
  border-left: 2px solid #17757a;
}

.uploadFile {
  /deep/ .el-button {
    background-color: #fff !important;
    color: #4d70fa !important;
    border-color: #fff !important;
    font-size: 16px !important;
    display: flex;
    align-items: center;
    padding: 0;
  }
}

.uploadTalent {
  /deep/ .el-button {
    color: #fff;
    background-color: #17757a;
    padding: 12px 20px;
    font-size: 14px;
    margin-left: 10px;
    // border: 1px solid #dcdfe6;
  }
}

.endTimeStyle {
  display: inline-block;
  width: 150px;
}

.candidateClass {
  /deep/ .el-dialog--center .el-dialog__body {
    padding-top: 0;
  }

  /deep/ .el-dialog__title {
    color: #333333;
    font-weight: 700;
  }

  p {
    font-size: 15px;
    font-weight: 700;
    margin: 10px 0;
    color: #333333 !important;
  }

  .search-input {
    width: 60%;

    /deep/ .el-input-group__append {
      background: #17757a;
      color: #fff;
      border: 1px solid #17757a;
    }

    /deep/ .el-button:focus,
    .el-button:hover {
      background-color: #17757a;
      color: #fff;
    }
  }

  /deep/ .el-button:focus,
  .el-button:hover {
    color: #17757a;
    background-color: #fff;
  }

  .targetEnterpriseContent {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;
      margin: 10px 0;

      .info {
        color: #1a1f33 !important;

        .companyFullName {
          font-size: 18px;
          margin-left: 5px;
        }

        .post {
          font-size: 15px;
          margin-left: 10px;
          display: flex;
          align-items: center;
        }

        .itemNo {
          color: #17757a;
          display: flex;
          align-items: center;
        }
      }

      .projectSchedule {
        // top: -22px;
        // position: absolute;
        margin: 10px 10px;
        font-size: 14px;
        color: #3fd356;

        span {
          display: inline-block;
          width: 10px;
          height: 10px;
          background-color: #3fd356;
          border-radius: 50%;
          margin-right: 5px;
        }
      }

      .earlier {
        color: #17757a;

        span {
          background-color: #17757a;
        }
      }

      .accomplish {
        color: #ffb847;

        span {
          background-color: #ffb847;
        }
      }

      .cancel {
        color: #a7a6a4;

        span {
          background-color: #a7a6a4;
        }
      }
    }
  }
}

.hasAddEnterprise {
  height: 400px;
  overflow: auto;

  p {
    color: #333333;
    font-weight: 700;
    padding: 10px 0;
    font-size: 14px;
    border-bottom: 1px solid #e5e5e5;
  }

  .targetEnterprise {
    border-bottom: 1px solid #e5e5e5;

    .right {
      display: flex;
    }
  }
}

/deep/.el-checkbox__inner {
  border: 1px solid #c4c4c4;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 81vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 78vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 80vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 74vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 71vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 77vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}
</style>
